import React from "react";
import styled from "@emotion/styled";
import BankCard from "@ecologi/assets/icons/bank-card.svg";
import { useMedia } from "react-use";
import { mobileUp } from "../theme/ecologi-breakpoints";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
`;

const CardNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const DotGroup = styled.span`
  display: flex;
  justify-content: center;
  gap: 6px;
`;

const Dot = styled.span`
  height: 4px;
  width: 4px;
  background-color: ${({ theme }) => theme.colors.forest};
  border-radius: 50%;
  display: inline-block;
`;

const CardNumberText = styled.span`
  color: ${({ theme }) => theme.colors.forest};
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 1.8rem;
`;

export const CardDetailsDisplay = ({
  lastFourDigits,
}: {
  lastFourDigits: string;
}) => {
  const isMobileUp = useMedia(mobileUp);

  return (
    <Container>
      <BankCard />
      <CardNumber>
        {isMobileUp && (
          <DotGroup>
            <Dot />
            <Dot />
            <Dot />
            <Dot />
          </DotGroup>
        )}

        <DotGroup>
          <Dot />
          <Dot />
          <Dot />
          <Dot />
        </DotGroup>

        <DotGroup>
          <Dot />
          <Dot />
          <Dot />
          <Dot />
        </DotGroup>

        <CardNumberText>{lastFourDigits}</CardNumberText>
      </CardNumber>
    </Container>
  );
};
